import { ComponentStyleConfig } from "@chakra-ui/theme";

export const Tabs: ComponentStyleConfig = {
    defaultProps: {
        variant: "line",
        colorScheme: "primary",
        size: ["sm", "md", "lg"],
    },
};
